var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"C-headline-publish-date"},[_vm._v("\n  "+_vm._s(_vm._f("formatCustomDate")(_vm.date,_vm.dateFormat))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }